/* eslint-disable no-unused-vars */
import React from "react";
// import { Flex, Typography } from "../../../ppui";
import { RiAddLine, } from "react-icons/ri";
import { TbAlertTriangle, TbPencil, TbPlus, TbTrash } from "react-icons/tb";
import { AllowanceBox } from "../../../../pages/style";
import {
  Box,
  Button,
  Col,
  Dialog,
  Divider,
  FabButton,
  Flex,
  Icon,
  InputField,
  Row,
  SelectField,
  Typography
} from "../../../../ppui";
import { logger } from "../../../../utils/logger";
import usePTaxServiceNew from "./use-p-tax-service";


const AdminPTax = () => {
  const {
    adminPTaxData,
    adminPTaxModal,
    adminPTaxModalOpen,
    adminPTaxModalClose,
    handleChange,
    errors,
    allStateList,
    adminPtaxInputs,
    handleAddTaxSlab,
    handleTaxSlabChange,
    handleRemoveTaxSlab,
    handleAddPTax,
    formUpdateLoading,
    handleClickOpenEditModal,
    handleClickOpenAddModal
  } = usePTaxServiceNew()
  logger.log(adminPTaxData, "adminPTaxData")
  logger.log(adminPtaxInputs, "adminPtaxInputs")

  return (
    <>
      <Flex justifyContent="space-between" mb={18} gap={"10"}>
        <Typography variant="h5" mb={"0"}>
          P-Tax
        </Typography>
        <Button onClick={handleClickOpenAddModal} variant="outlined" size="sm">
          Create New
        </Button>
      </Flex>

      {adminPTaxData?.length === 0 ? (
        <AllowanceBox mb={20}>
          <Icon color={"danger"} size={"lg"}>
            <TbAlertTriangle />
          </Icon>
          <Typography
            variant="body1"
            display="flex"
            gap={10}
            alignItem="center"
            mb={"0"}
            p={15}
          >
            No predefined P-Tax data available.
          </Typography>
        </AllowanceBox>
      ) : (
        <Flex gap={20} direction={"column"}>
          {adminPTaxData.map((data, index) => (
            <AllowanceBox key={index}>
              <Row alignItems="center">
                <Col xs={11}>
                  <Flex alignItems="center" gap={{ md: 20, lg: 40, xxl: 60 }}>
                    <Box>
                      <Box className="label">State</Box>
                      <Box className="value">{data?.indian_states?.state_name ? data?.indian_states?.state_name : 'N/A'}</Box>
                    </Box>

                    <Box>
                      <Box className="label">Session</Box>
                      <Box className="value">{data?.year ? data?.year : 'N/A'}-{data?.to_year ? data?.to_year : 'N/A'}</Box>
                    </Box>
                  </Flex>
                </Col>

                <Col xs={1}>
                  <Box>
                    <FabButton
                      size="sm"
                      icon={<TbPencil />}
                      onClick={() => handleClickOpenEditModal(data)}
                      variant="filled"
                      shape="box"
                    />
                  </Box>
                </Col>
              </Row>
            </AllowanceBox>
          ))}
        </Flex>
      )}

      {/* P-Tax */}

      <Dialog
        title="P-Tax"
        closeButton={true}
        fullWidth
        maxWidth="md"
        open={adminPTaxModal}
        onClose={adminPTaxModalClose}
        separator
        onSubmit={handleAddPTax}
        btnLoading={formUpdateLoading}
        bodyScroll={true}
      >
        <Row rowGap={20}>
          <Col sm={12} md={6}>
            <SelectField
              fullWidth
              required
              label="State"
              options={allStateList}
              placeholder="Select Here..."
              defaultValue={adminPtaxInputs?.state_id}
              valueSinc={!!adminPtaxInputs?.state_id}
              onChange={(val) => handleChange(val, "state_id")}
            // error={errors.state_id}
            // helperText={errors.state_id}
            />
          </Col>

          <Col sm={12} md={6}>
            <SelectField
              fullWidth
              required
              label="Financial Year"
              options={[
                { id: "2023-2024", name: "2023-2024" },
                { id: "2024-2025", name: "2024-2025" },
              ]}
              placeholder="Select Here..."
              defaultValue={adminPtaxInputs?.session}
              valueSinc={!!adminPtaxInputs?.session}
              onChange={(val) => handleChange(val, "session")}
            />
          </Col>
        </Row>

        <Divider gap={20} />


        {adminPtaxInputs.tax_cal.map((slab, index) => (
          <div key={index}
          >
            <Typography variant="h5" mb={"20"}>
              Professional Tax Slab {index + 1}
            </Typography>
            <Row rowGap={20}>
              <Col sm={12} lg={3}>
                <InputField
                  required
                  fullWidth
                  label="Minimum Value"
                  type="number"
                  placeholder="Type Here"
                  value={slab?.min_salary}
                  valueSinc={!!slab.min_salary}
                  onChange={(e) => handleTaxSlabChange(e.target.value, 'min_salary', index)}
                />
              </Col>
              {/* {index !== adminPtaxInputs.tax_cal.length - 1 && ( */}
                <Col sm={12} lg={3}>
                  <InputField
                    required
                    fullWidth
                    label="Maximum Value"
                    type="number"
                    placeholder="Type Here"
                    value={slab.max_salary}
                    valueSinc={!!slab.max_salary}
                    onChange={(e) => handleTaxSlabChange(e.target.value, 'max_salary', index)}
                  />
                </Col>
              {/* )} */}
              <Col sm={12} lg={3}>
                <InputField
                  required
                  fullWidth
                  label="Amount"
                  type="number"
                  placeholder="Type Here"
                  value={slab.tax_amount}
                  valueSinc={!!slab.tax_amount}
                  onChange={(e) => handleTaxSlabChange(e.target.value, 'tax_amount', index)}
                />
              </Col>

              <Col sm={"auto"} ml={"auto"}>
                <Flex gap={10}>
                  <FabButton
                    color="primary"
                    icon={<TbTrash />}
                    shape="box"
                    variant="outlined"
                    onClick={() => handleRemoveTaxSlab(index)}
                  />
                </Flex>
              </Col>
            </Row>
            <Divider gap={20} />
          </div>
        ))}


        <Flex justifyContent="flex-end" mt={20}>
          <FabButton
            color="primary"
            icon={<TbPlus />}
            shape="box"
            onClick={handleAddTaxSlab}
          />
        </Flex>
      </Dialog>

      {/* P-Tax */}
    </>
  );
};

export default AdminPTax;
